import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import NotificationLayer from "../components/NotificationLayer";
import ReceivedNotifications from "../components/ReceivedNotifications";

const NotificationPage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Settings - Notification" />

        {/* NotificationLayer */}
        <NotificationLayer />

        {/* ReceivedNotifications */}
        <div className="mt-24">
            <ReceivedNotifications />
        </div>

      </MasterLayout>

    </>
  );
};

export default NotificationPage; 
